<template>
  <div class="home">
    <landing-section />
    <LearningPath />
    <TopicSection />
  </div>
</template>

<script>
import TopicSection from "@/components/home/TopicSection.vue";
import LearningPath from "@/components/home/LearningPath.vue";
import LandingSection from "@/components/home/LandingSection.vue";

export default {
  components: { TopicSection, LearningPath, LandingSection },
};
</script>

<style lang="scss">
.home {
  height: 100%;
  width: 100%;
  //position: relative;
  //top: 38px;
}
</style>
